<style>
  .alert-md-color {
    background-color: #7B1FA2;
    border-color: #4A148C;
    color: #fff;
  }
</style>
<alert type="md-color">
  <strong>Well done!</strong> You successfully read this important alert message.
</alert>
